/* unplugin-vue-components disabled */import script from "./dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog.vue?vue&type=script&setup=true&lang=js"

import "./dialog.vue?vue&type=style&index=0&id=f12473c8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f12473c8"]])

export default __exports__